import React from "react";
import classes from './MainButton.module.css';
import { Typography } from "@mui/material";

const MainButton: React.FC<React.PropsWithChildren & {url: string}> = ({children, url}) => {
    return <button className={classes['btn']}>
        <a href={url} target="_blank" rel="noreferrer">
            <Typography variant="h6" sx={{fontWeight: 600}}>
                {children}
            </Typography>
        </a>
    </button>
};

export default MainButton;